module.exports = __webpack_public_path__ + "static/img/gift_pt.4ec8df26.png";